// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface XAvatarProps {
    firstName?: string;
    lastName?: string;
    width?: string;
    height?: string;
    square?: boolean;
}
const XAvatar = ({ firstName, lastName, width, height, square }: XAvatarProps) => {
    return (
        <StyledWrapper
            css={css`
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: ${square ? "0" : "50%"};
                border: ${square ? "0" : "1px solid"};
                border-color: ${getColor("primary")};
                width: ${width || "55"}px;
                height: ${height || "55"}px;
                font-size: 22px;
                text-transform: uppercase;
                background: ${getColor("common.ui4")};
            `}
        >
            {firstName && lastName ? <>{firstName[0] + lastName[0]}</> : <>{firstName ? firstName[0] : ""}</>}
        </StyledWrapper>
    );
};

export default XAvatar;
